import {IUserTicketPrize} from "../../firebase/topics/in-game-challenges/tickets-update/user-tickets-update-topic.model.interface";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {InGameTicketPrizeType} from "./abstract/in-game-ticket-prize-types";
import {InGameTicketPrizeAbstract} from "./abstract/in-game-ticket-prize.abstract";

/**
 * https://evokeplc.atlassian.net/wiki/spaces/CRMSX/pages/542710740/Bonus+Types
 * Immediate bonus 
 * 
 * Affects player’s BR (granted to restricted money wallet)
 * The player can use the money for betting only
 * To get the bonus into real bankroll, member must complete wagering requirements (accumulate points)
 * Can be valid for specific offer/s (i.e. casino only)
 * 
 * a.k.a for us "$xx.xx bonus"
 */
export class InGameTicketImmediateBonusPrize extends InGameTicketPrizeAbstract {
    constructor(protected _prizeData: IUserTicketPrize, private services: IServiceFactoryExtended) {
        if (InGameTicketPrizeType.ImmediateBonus !== _prizeData.prizeType) {
            throw new Error("Immediate Bonus cannot be given this prizeType" + _prizeData.prizeType);
        }
        super(_prizeData);
    }
    public prizeString() {
        return this.services.currency.formatMoney(this._prizeData.prizeValue);
    }
}
